import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";
import { catchError, fromEvent, map, merge, of, Subscription } from "rxjs";
import { Configuration } from "src/app/_core/models/configuration.model";
import { ConfigurationService } from "src/app/_core/services/configuration.service";
import {
  BrowserMetaData,
  DeviceInfo,
} from "src/app/_models/two-fa/browser-metadata";

@Injectable({
  providedIn: "root",
})
export class BrowserInfoService {
  networkStatus: boolean = false;
  config: Configuration;
  networkStatusSubscription: Subscription = Subscription.EMPTY;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService,
    private deviceService: DeviceDetectorService
  ) {
    this.configurationService.getJSONwithAPI().subscribe((res) => {
      this.config = res as Configuration;
    });
  }

  getBrowserName(): string {
    const agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf("edge") > -1) return "Microsoft Edge";
    if (agent.indexOf("edg") > -1) return "Edge (Chromium)";
    if (agent.indexOf("opr") > -1) return "Opera";
    if (agent.indexOf("chrome") > -1) return "Chrome";
    if (agent.indexOf("trident") > -1) return "Internet Explorer";
    if (agent.indexOf("firefox") > -1) return "Firefox";
    if (agent.indexOf("safari") > -1 && agent.indexOf("chrome") === -1)
      return "Safari";
    return "Unknown";
  }

  getOS(): string {
    const agent = navigator.userAgent.toLowerCase();
    if (agent.indexOf("windows") > -1) return "Windows";
    if (agent.indexOf("mac") > -1) return "Mac";
    if (agent.indexOf("linux") > -1) return "Linux";
    if (agent.indexOf("android") > -1) return "Android";
    if (agent.indexOf("ios") > -1) return "iOS";
    return "Unknown";
  }

  getLocalIP() {
    const RTCPeer = window.RTCPeerConnection;
    if (RTCPeer) {
    } else {
      console.error("WebRTC is not supported in this browser/environment");
    }
  }

  getDeviceInfo(): DeviceInfo {
    return this.deviceService.getDeviceInfo();
  }

  getBrowserMetaData() {
    if (this.config.setting.IsInternetAllow) {
      return this.http.get<BrowserMetaData>("https://ipinfo.io/json").pipe(
        catchError((error) => {
          return of(new BrowserMetaData());
        })
      );
    } else {
      return of(new BrowserMetaData());
    }
  }

  checkNetworkStatus() {
    this.networkStatus = navigator.onLine;
    this.networkStatusSubscription = merge(
      of(null),
      fromEvent(window, "online"),
      fromEvent(window, "offline")
    )
      .pipe(map(() => navigator.onLine))
      .subscribe((status) => {
        this.networkStatus = status;
      });
  }
}
